import { Component, OnInit } from '@angular/core';
import { CreateResult } from '../../models/create-result';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminalService } from '../../services/terminal.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { TerminalSignUpViewModel } from '../../models/terminal-signup-view-model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeleteTerminalSignUpViewModel } from '../../models/delete-teminal-singup-view-model';

@Component({
  selector: 'app-delete-ticket',
  templateUrl: './delete-ticket.component.html',
  styleUrls: ['./delete-ticket.component.scss']
})
export class DeleteTicketComponent implements OnInit {

  public createResult: CreateResult;
  public isBulk: boolean;
  public terminalSignUp: TerminalSignUpViewModel = {
    id: 0,
    changedOn: '',
    changedBy: '',
    source: '',
    merchantName: '',
    merchantNumber: '',
    terminalId: '',
    participantId: 0,
    status: '',
    date: '',
    comments: '',
    wayBill: '',
    data: '',
    trackingId: '',
    priority: '',
    type: '',
    form: '',
    brand: '',
    inUseBy: '',
    inUseById: '',
    inUseDate: '',
    serialNumber: '',
    baseSerialNumber: '',
    simNumber: '',
    dispatch: false,
    deliveryMethod: '',
    retail: '',
    admin: '',
    sameAsMerchantAddress: false,
    make: '',
    model: '',
    bulkOrder: false,
    deviceOwnership: ''
  };
  public notes: string = '';
  public TerminalFormGroup: FormGroup;
  constructor(
    private _modal: NgbActiveModal,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder) { }

  ngOnInit() {
    this.TerminalFormGroup = this._formBuilder.group({
      noteFC: ['', Validators.compose([Validators.required])]
    });
  }


  async delete() {
    
    if (this.TerminalFormGroup.controls['noteFC'].value == '') {
      this._toastService.error("Please provide a reason.", "Error");
      return;
    }

    let deleteTerminal = {} as DeleteTerminalSignUpViewModel;
    deleteTerminal.terminal = this.terminalSignUp;
    deleteTerminal.note = this.TerminalFormGroup.controls['noteFC'].value;
    deleteTerminal.bulkOrder = this.isBulk;
    debugger;
    this.createResult = await this._terminalService.DeleteTicket(deleteTerminal);
    debugger;
    if (!this.createResult.success) { 
      this._toastService.error(this.createResult.message, "Error");
      return;
    }
    this._toastService.success(this.createResult.message, "Success");
    this.close();
  }

  close() {
    this._modal.close();
  }
}
